import angular from 'angular';

angular.module('myConsultApp').factory('utilitiesV2', () => {
  return {
    bindAbsoluteElementToScrollContainer: (
      container,
      element,
      boundElementSelector,
      forceBindBelow,
    ) => {
      const bindElement = () => {
        const boundElement = document.querySelector(boundElementSelector);
        if (!container || !element || !boundElement) {
          return;
        }

        const isBoundElementAbove =
          boundElement.getBoundingClientRect().top < element.getBoundingClientRect().top;

        const newBoundElementTop =
          isBoundElementAbove && !forceBindBelow
            ? window.pageYOffset + element.getBoundingClientRect().top - boundElement.offsetHeight
            : window.pageYOffset + element.getBoundingClientRect().top + element.offsetHeight;

        boundElement.style.top = `${newBoundElementTop}px`;
      };

      container.on('scroll', bindElement);
    },

    sortArrayByDate: ({ array, ascending = true, sortField }) => {
      return array.sort((a, b) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return ascending
          ? new Date(a[sortField]) - new Date(b[sortField])
          : new Date(b[sortField]) - new Date(a[sortField]);
      });
    },
  };
});
